import SourceManagerColumn from './SourceManagerColumn';

export default SourceManagerColumn;
